import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const OpenWithIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 9H13V5H16L12.3536 1.35355C12.1583 1.15829 11.8417 1.15829 11.6464 1.35355L8 5H11V9ZM9 11H5V8L1.35355 11.6464C1.15829 11.8417 1.15829 12.1583 1.35355 12.3536L5 16V13H9V11ZM22.6464 12.3536C22.8417 12.1583 22.8417 11.8417 22.6464 11.6464L19 8V11H15V13H19V16L22.6464 12.3536ZM13 15H11V19H8L11.6464 22.6464C11.8417 22.8417 12.1583 22.8417 12.3536 22.6464L16 19H13V15Z"
          fill="#333333"
        />
      </svg>
    )
  },
)
